import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"pa-0":""}},[_c(VRow,[_c('div',{staticClass:"page__title"},[_c('div',[_c('h1',[_vm._v("Historia aktywności")])])])]),_c('list-wrapper',{attrs:{"total":_vm.count,"per-page":16}},[_c('history',{attrs:{"title":"Historia","show-more":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }